import {createSlice} from '@reduxjs/toolkit'

const initialSystemInfo = () => {
    return {}
}

export const systemInfoSlice = createSlice({
    name: 'systemInfo',
    initialState: {
        data: initialSystemInfo()
    },
    reducers: {
        setSystemInfo: (state, action) => {
            state['data'] = {...state['data'], ...action.payload}
        }
    }
})

export const {setSystemInfo} = systemInfoSlice.actions

export default systemInfoSlice.reducer